export default import.meta.ROLLUP_FILE_URL_S4TktFj7;